import React from 'react';
import { bool, func } from 'prop-types';

import { FormattedMessage } from '../../util/reactIntl';

import css from './SearchPage.module.css';

const FavoritesFilterCheckbox = ({ checked, onChange }) => (
  <label className={css.favoritesCheckbox}>
    <input
      type="checkbox"
      className={css.favoritesCheckboxInput}
      checked={checked}
      onChange={event => onChange(event.target.checked)}
    />
    <span className={css.favoritesCheckboxBox} aria-hidden="true" />
    <span className={css.favoritesCheckboxText}>
      <FormattedMessage id="SearchPage.favorites" />
    </span>
  </label>
);

FavoritesFilterCheckbox.propTypes = {
  checked: bool.isRequired,
  onChange: func.isRequired,
};

export default FavoritesFilterCheckbox;
